import { ThemeContext } from '@contexts/theme';
import { createContextWithSelector } from '@utils';

export const useEventfyTheme = createContextWithSelector(
  ThemeContext,
  'useEventfyTheme',
);
